"use client";
import { cn } from "@/lib/utils";
import Marquee from "./marquee";
import { Badge } from "@/components/ui/badge";

const testimonials = [
  {
    name: "Jonathan Yombo",
    position: "Software Engineer",
    text: "Tailus is really extraordinary and very practical, no need to break your head. A real gold mine.",
    img: "https://i.pravatar.cc/150?img=41",
  },
  {
    name: "Yves Kalume",
    position: "GDE - Android",
    text: "With no experience in webdesign I just redesigned my entire website in a few minutes with tailwindcss thanks to Tailus.",
    img: "https://i.pravatar.cc/150?img=42",
  },
  {
    name: "Yucel Faruksahan",
    position: "Tailkits Creator",
    text: "Tailus is redefining the standard of web design, with these blocks it provides an easy and efficient way for those who love beauty but may lack the time to implement it. I can only recommend this incredible wonder.",
    img: "https://i.pravatar.cc/150?img=43",
  },
  {
    text: "Fazier crushes... had our best couple days ever and you've provided the most traffic to the site this month, and still driving sales to SvelteLaunch.",
    name: "Travis Mathis",
    position: "Founder of SvelteLaunch",
    img: "https://i.pravatar.cc/150?img=44",
  },
  {
    text: "I launched my 500K Agency offer in April. The community support was more than anything I could have expected.",
    name: "Paul Xue",
    position: "Founder of Spacestation Labs",
    img: "https://i.pravatar.cc/150?img=45",
  },
  {
    text: "Sweet! Fazier is awesome!",
    name: "Tyler Shukert",
    position: "DevRel engineer at Supabase",
    img: "https://i.pravatar.cc/150?img=46",
  },
  {
    text: "Hit the ground running on Fazier... A top-tier alternative to ProductHunt. 14.5% of my traffic came from there. Highly recommend it!",
    name: "Nathan Chua",
    position: "Founder of Snipowl",
    img: "https://i.pravatar.cc/150?img=47",
  },
  {
    text: "Definitely helped us make more sales!",
    name: "Tim White",
    position: "VP of Marketing, Founder of WildSEO",
    img: "https://i.pravatar.cc/150?img=48",
  },
  {
    text: "Fazier helped me to get a lot of traffic and feedback about my products. Thank you for the project!",
    name: "Serg Karakhanyan",
    position: "Founder of Larafast",
    img: "https://i.pravatar.cc/150?img=49",
  },
  {
    text: "I launched my 500K Agency offer in April. The community support was more than anything I could have expected.",
    name: "Paul Xue",
    position: "Founder of Spacestation Labs",
    img: "https://i.pravatar.cc/150?img=52",
  },
  {
    text: "Sweet! Fazier is awesome!",
    name: "Tyler Shukert",
    position: "DevRel engineer at Supabase",
    img: "https://i.pravatar.cc/150?img=53",
  },
  {
    text: "Hit the ground running on Fazier... A top-tier alternative to ProductHunt. 14.5% of my traffic came from there. Highly recommend it!",
    name: "Nathan Chua",
    position: "Founder of Snipowl",
    img: "https://i.pravatar.cc/150?img=54",
  },
  {
    text: "Definitely helped us make more sales!",
    name: "Tim White",
    position: "VP of Marketing, Founder of WildSEO",
    img: "https://i.pravatar.cc/150?img=55",
  },
  {
    text: "Fazier helped me to get a lot of traffic and feedback about my products. Thank you for the project!",
    name: "Serg Karakhanyan",
    position: "Founder of Larafast",
    img: "https://i.pravatar.cc/150?img=56",
  },
  {
    text: "Fazier crushes... had our best couple days ever and you've provided the most traffic to the site this month, and still driving sales to SvelteLaunch.",
    name: "Travis Mathis",
    position: "Founder of SvelteLaunch",
    img: "https://i.pravatar.cc/150?img=44",
  },
  {
    text: "I launched my 500K Agency offer in April. The community support was more than anything I could have expected.",
    name: "Paul Xue",
    position: "Founder of Spacestation Labs",
    img: "https://i.pravatar.cc/150?img=45",
  },
  {
    text: "Sweet! Fazier is awesome!",
    name: "Tyler Shukert",
    position: "DevRel engineer at Supabase",
    img: "https://i.pravatar.cc/150?img=46",
  },
];

export default function WallOfLove03() {
  return (
    <section className="pb-20 pt-20 md:pb-32 md:pt-32 container mx-auto">
      <div className="text-center space-y-4 pb-16 mx-auto max-w-4xl">
        <Badge>TESTMONIALS</Badge>
        <h2 className="mx-auto mt-4 text-3xl font-bold sm:text-5xl tracking-tight">
          Explore the Future of Innovation
        </h2>
        <p className="text-xl text-muted-foreground pt-1">
          In a realm where imagination meets technology, our platform fosters
          innovation, inspires creativity, and empowers every individual to
          transform their vision into reality.
        </p>
      </div>
      <div className="relative mt-6 max-h-screen overflow-hidden">
        <style>
          {`
          @keyframes marquee {
            from { transform: translateX(0); }
            to { transform: translateX(-100%); }
          }
          @keyframes marquee-vertical {
            from { transform: translateY(0); }
            to { transform: translateY(-100%); }
          }
          .animate-marquee {
            animation: marquee 20s linear infinite;
          }
          .animate-marquee-vertical {
            animation: marquee-vertical 20s linear infinite;
          }
        `}
        </style>
        <div className="gap-4 md:columns-2 xl:columns-3 2xl:columns-4">
          {Array(Math.ceil(testimonials.length / 3))
            .fill(0)
            .map((_, i) => (
              <Marquee
                vertical
                reverse={i === 0 || i === 3}
                key={i}
                className={cn({
                  "[--duration:30s]": i === 0,
                  "[--duration:31s]": i === 1,
                  "[--duration:32s]": i === 2,
                  "[--duration:33s]": i === 3,
                })}
              >
                {testimonials
                  .slice(i * 3, (i + 1) * 3)
                  .map((testimonial, idx) => (
                    <div key={idx} className="flex justify-center min-w-full">
                      <TestimonialCard
                        name={testimonial.name}
                        position={testimonial.position}
                        text={testimonial.text}
                        img={testimonial.img}
                      />
                    </div>
                  ))}
              </Marquee>
            ))}
        </div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/4 w-full bg-gradient-to-t from-background from-20%"></div>
        <div className="pointer-events-none absolute inset-x-0 top-0 h-1/4 w-full bg-gradient-to-b from-background from-20%"></div>
      </div>
    </section>
  );
}

function TestimonialCard({
  name,
  position,
  text,
  img,
}: {
  name: string;
  position: string;
  text: string;
  img: string;
}) {
  return (
    <div className="p-6 ring-1 ring-primary rounded-2xl shadow-xl text-card-foreground hover:bg-accent break-inside-avoid min-w-full">
      <div className="flex flex-col">
        <div className="flex gap-3 items-center">
          <Avatar img={img} alt={name} />
          <div className="flex flex-col">
            <h3 className="font-medium text-foreground">{name}</h3>
            <span className="block text-sm text-muted-foreground">
              {position}
            </span>
          </div>
        </div>
        <blockquote className="mt-3">
          <p className="text-muted-foreground">{text}</p>
        </blockquote>
      </div>
    </div>
  );
}

function Avatar({ img, alt }: { img: string; alt: string }) {
  return (
    <div className="w-12 h-12">
      <img
        className="h-full w-full rounded-full object-cover"
        src={img}
        alt={alt}
        loading="lazy"
        width={48}
        height={48}
      />
    </div>
  );
}
